// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-preview {\n  max-width: 700px;\n  border-bottom: #4e4250 1px solid;\n  margin-bottom: 2rem;\n  margin-top: 2rem;\n}\n\n.trimmed-content-wrapper {\n  max-height: 60px;\n  position: relative;\n  overflow: hidden;\n}\n.trimmed-content-wrapper .gradient-background {\n  \n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  background: linear-gradient(180deg, rgba(255,255,255,0) 40%, var(--main-canvas) 100%);\n}", ""]);
// Exports
module.exports = exports;
